const ComingSoon = () => {
    return (
        <>
            <h1 className="title is-2">Coming Soon</h1>
            <p>Lorem ipsum</p>
        </>
    )
}

export default ComingSoon;